import {
	CURRENCYCONFIG,
	type CURRENCYSYMBOLTYPE,
	FXCONVERSION,
	type FXCONVERSION_TYPE,
	FXRATE,
	type FXRATE_TYPE,
	getFxRateByCountry,
	type IUseCurrentFXRate,
} from 'BreetHelpers';
import { useCurrencyOutput } from 'BreetHooks';
import { selectAuthSettings, selectFiatMeta, useAppSelector } from 'BreetRedux';

export const useCurrentFxRate = ({
	fxRate = FXRATE.DEFAULT,
	conversionType = FXCONVERSION.SELLUSD,
}: {
	fxRate?: FXRATE_TYPE;
	conversionType?: FXCONVERSION_TYPE;
}): IUseCurrentFXRate => {
	const currencyOutput = useCurrencyOutput();

	const fiatMeta = useAppSelector(selectFiatMeta);

	const authSettings = useAppSelector(selectAuthSettings);

	const currentRate = getFxRateByCountry(
		fiatMeta.countryLower,
		fxRate === FXRATE.BUY ? authSettings?.fxRates.buy : authSettings?.fxRates
	);

	const rateObj: Record<FXCONVERSION_TYPE, number> = {
		[FXCONVERSION.NGNToGHS]: authSettings?.fxRates.NGNToGHS ?? 0,
		[FXCONVERSION.GHSToNGN]: authSettings?.fxRates.NGNToGHS ? 1 / authSettings.fxRates.NGNToGHS : 0,
		[FXCONVERSION.FIATToUSD]: currentRate,
		[FXCONVERSION.SELLUSD]: currentRate,
	};

	const rate = currencyOutput(rateObj[conversionType]);

	const fromSymbolObj: Record<FXCONVERSION_TYPE, CURRENCYSYMBOLTYPE> = {
		[FXCONVERSION.NGNToGHS]: CURRENCYCONFIG.NGN.symbol,
		[FXCONVERSION.GHSToNGN]: CURRENCYCONFIG.GHS.symbol,
		[FXCONVERSION.FIATToUSD]: fiatMeta.currencySymbol,
		[FXCONVERSION.SELLUSD]: CURRENCYCONFIG.USD.symbol,
	};

	const fromSymbol = fromSymbolObj[conversionType];

	const toSymbolObj: Record<FXCONVERSION_TYPE, CURRENCYSYMBOLTYPE> = {
		[FXCONVERSION.NGNToGHS]: CURRENCYCONFIG.GHS.symbol,
		[FXCONVERSION.GHSToNGN]: CURRENCYCONFIG.NGN.symbol,
		[FXCONVERSION.FIATToUSD]: CURRENCYCONFIG.USD.symbol,
		[FXCONVERSION.SELLUSD]: fiatMeta.currencySymbol,
	};

	const toSymbol = toSymbolObj[conversionType];

	const rateInfoFrom = fromSymbol !== '$' ? fromSymbol : toSymbol;
	const rateInfoTo = fromSymbol !== '$' ? toSymbol : fromSymbol;
	const rateInfo = `${rateInfoFrom}${rate} / ${rateInfoTo}`;

	return {
		rate,
		rateInfo,
		rateInfoSymbol: {
			from: rateInfoFrom,
			to: rateInfoTo,
		},
		symbol: {
			from: fromSymbol,
			to: toSymbol,
		},
	};
};
